// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__JAs0R","title":"Contact_title__4C6eS"};